import { render, staticRenderFns } from "./ReportEditor.vue?vue&type=template&id=18a73c32&scoped=true"
import script from "./ReportEditor.vue?vue&type=script&lang=ts"
export * from "./ReportEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a73c32",
  null
  
)

export default component.exports